import { useCallback } from 'react';

import { useCanvas } from '../../../../core/components/canvas/hooks/useCanvas.js';
import { DATA_POINT_OUTER_RADIUS } from '../../../../core/components/data-point/constants.js';
import { getStrokeColor } from '../../../../core/components/data-point/utils/data-point.js';
import { DEFAULT_DATA_POINT_RADIUS } from '../../../../core/constants.js';
import { DataPoint } from '../../../../core/types/data-point.js';
import {
  drawPill,
  drawShapeFill,
  drawShapeStroke,
} from '../utils/draw-shape.js';

interface HighlightedDatapointCanvasProps {
  selectionPoints: DataPoint[];
  hoverGroups: DataPoint[][];
}

export const HighlightedPointCanvas = ({
  selectionPoints,
  hoverGroups,
}: HighlightedDatapointCanvasProps) => {
  const draw = useCallback(
    (ctx: CanvasRenderingContext2D) => {
      for (const group of hoverGroups) {
        if (group.length >= 2) {
          drawPill(ctx, group, getStrokeColor(group));
          for (const point of group) {
            drawShapeFill(ctx, point, DEFAULT_DATA_POINT_RADIUS);
          }
        } else {
          drawShapeStroke(
            ctx,
            group[0],
            DATA_POINT_OUTER_RADIUS,
            getStrokeColor(group),
          );
          drawShapeFill(ctx, group[0], DEFAULT_DATA_POINT_RADIUS);
        }
      }

      const selectionStrokeColor = getStrokeColor(selectionPoints);
      for (const point of selectionPoints) {
        drawShapeStroke(
          ctx,
          point,
          DATA_POINT_OUTER_RADIUS,
          selectionStrokeColor,
        );
        drawShapeFill(ctx, point, DEFAULT_DATA_POINT_RADIUS);
      }

      return false;
    },
    [selectionPoints, hoverGroups],
  );

  useCanvas('Highlighted-DataPoints', draw);

  return null;
};
